import { Link } from 'react-router-dom';
import RoutesPage from './RoutesPage';
import home from "./assets/home.png"
import WhatsApp from'./assets/WhatsApp.svg';

function App() {
    const openWhatsApp = () => {
        const phoneNumber = "+96898001911"; // Replace with the actual phone number

    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };
  return (
<div className='h-100 App'>
<RoutesPage/>
<div className='bg-white'style={{
          position: "fixed",
        bottom: "20px",
        left: "20px",
        backgroundColor: "#25D366",
        color: "white",
        border: "none",
        padding: "10px 12px",
        borderRadius: "50%",
        fontSize: "18px",
        cursor: "pointer",
        boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",

}}>
  <Link to="/"><img src={home}alt=''/></Link>
  </div>
  <button
      onClick={openWhatsApp}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#25D366",
        color: "white",
        border: "none",
        padding: "10px 12px",
        borderRadius: "50%",
        fontSize: "18px",
        cursor: "pointer",
        boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
      }}
    >
      <img src={WhatsApp}alt='WhatsApp'
      style={{
        width:"25px"
      }}
      />
    </button>
</div>
  );
}

export default App;
